module.exports = __webpack_public_path__ + "static/media/overpass-light-italic.5b90b726.woff";